/**
 * Quản lý chế độ sáng/tối (B1 — v0.18).
 * Lưu lựa chọn trong localStorage; nếu chưa chọn thì theo hệ điều hành.
 */
export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'v75-theme'

/** Đọc theme đã lưu, fallback theo `prefers-color-scheme`. */
export function getStoredTheme(): Theme {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'light' || saved === 'dark') return saved
  } catch { /* localStorage bị chặn — dùng mặc định hệ thống */ }
  const prefersDark = typeof window !== 'undefined'
    && window.matchMedia?.('(prefers-color-scheme: dark)').matches
  return prefersDark ? 'dark' : 'light'
}

/** Gắn class `dark` lên <html> theo theme. */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement
  root.classList.toggle('dark', theme === 'dark')
}

/** Lưu + áp dụng theme. */
export function setTheme(theme: Theme): void {
  try { localStorage.setItem(STORAGE_KEY, theme) } catch { /* bỏ qua */ }
  applyTheme(theme)
}

/** Gọi 1 lần lúc khởi động (trước render) để tránh nháy màu. */
export function initTheme(): void {
  applyTheme(getStoredTheme())
}
